import React, { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';
import { ReactComponent as Play } from '../../assets/svg/Play.svg'
import { ReactComponent as Pause } from '../../assets/svg/Pause.svg'


const AudioPlayer = ({ fileUrl }) => {
    const waveformRef = useRef(null);
    const wavesurfer = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const controller = new AbortController();

    const togglePlayPause = () => {
        if (wavesurfer.current) {
            wavesurfer.current.playPause();
            setIsPlaying(wavesurfer.current.isPlaying());
        }
    };

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60)
            .toString()
            .padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    useEffect(() => {
        if (!fileUrl || !waveformRef.current) return;

        const ws = WaveSurfer.create({
            container: waveformRef.current,
            backend: 'MediaElement',
            waveColor: '#636B70',
            progressColor: '#A6ABAD',
            barWidth: 3,
            barRadius: 3,
            responsive: true,
            height: 30,
            normalize: true,
            cursorWidth: 0,
            interact: true,
            url: fileUrl,
            fetchParams: {
                signal: controller.signal,
            },
        });

        wavesurfer.current = ws;

        const loadAudio = async () => {
            try {
                ws.load(fileUrl);
            } catch (err) {
                console.error('Error loading audio:', err);
            }
        };

        loadAudio();

        ws.on('ready', () => {
            setDuration(ws.getDuration());
        });

        ws.on('audioprocess', () => {
            setCurrentTime(ws.getCurrentTime());
        });

        ws.on('seek', () => {
            setCurrentTime(ws.getCurrentTime());
        });

        ws.on('finish', () => {
            setIsPlaying(false);
            setCurrentTime(0);
        });

        return () => {
            if (wavesurfer.current) {
                wavesurfer.current.destroy();
            };
        }
    }, [fileUrl]);

    return (
        <div className="audio-preview-card">
            <div className="play-pause-button" onClick={togglePlayPause}>
                {isPlaying ? <Pause /> : <Play />}
            </div>
            <div ref={waveformRef} className='sound-wave' />
            <div className="duration-time">
                {formatTime(currentTime)} / {formatTime(duration)}
            </div>
        </div>
    );
};

export default AudioPlayer;
